module.controller('lifeProofNoModelCntrl', function(xmppAuth,  $location, esb, services, $scope, $rootScope, $sce, $cookieStore, $mdToast, $mdDialog, $window, $q, $timeout, $interval, theme, $localStorage, cryptool) {
  $scope.data = JSON.parse($window.localStorage.getItem("metadataObj"));
  var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
  var xmppUser = $window.sessionStorage.getItem('userXmpp')
  
  $scope.showAlert = function (msg, title) {
    $scope.progress = undefined;
    $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#popupContainer"))).title(msg).clickOutsideToClose(false).textContent(title).ariaLabel("Alert Dialog Demo").ok("Ok"));
};
  $scope.onPositionUpdate = function(position) {
    $window.localStorage.setItem("locationPermission", "true");
    $scope.latitude = position.coords.latitude;
    $scope.longitude = position.coords.longitude;
}
  if (navigator.geolocation){
      var showLockMessage = false;
      if(!$window.localStorage.getItem("locationPermission")){            
       
      }
      else{
        if( $window.localStorage.getItem("locationPermission") && $window.localStorage.getItem("locationPermission") === 'lock')
          showLockMessage = true;
      }
      navigator.geolocation.getCurrentPosition($scope.onPositionUpdate, function (err){

        switch (err.code) {
          // PERMISSION_DENIED
          case 1:
            console.log('Permission denied')
            $window.localStorage.setItem("locationPermission", "lock");               
            break
          // POSITION_UNAVAILABLE
          case 2:
            console.log('Permission allowed, location disabled')
            break
          // TIMEOUT
          case 3:
            console.log('Permission allowed, timeout reached')
            break
        }

        $scope.latitude = 0.0;
        $scope.longitude = 0.0;
      });

  }
  else{
    $scope.latitude = 0.0;
    $scope.longitude = 0.0; 
  } 

 $scope.desktop = window.innerWidth > 700;

  $scope.theme = theme.getTheme(); 
    $scope.closeDialog = function(){
      $('#imagesTest').empty();
      $('#imagesTaked').empty();

      $timeout.cancel($scope.currentTimer);
      $timeout.cancel($scope.currentCompleteTimer);
      $rootScope.$broadcast('closeFaceTracker'); 
      stopCapture()
      webcam.stop();    
    };

    
    $scope.cancelDialog = function(){
  
      $('#imagesTest').empty();
      $('#imagesTaked').empty();
      $timeout.cancel($scope.currentTimer);
      $timeout.cancel($scope.currentCompleteTimer);
      $scope.cancelled = true; 
      stopCapture()
      webcam.stop();
      $location.path("/dashboard");
    }; 

  function shuffle(array) {
      var currentIndex = array.length,  randomIndex; 
      // While there remain elements to shuffle...
      while (0 !== currentIndex) { 
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--; 
        origObj = array[currentIndex]; 
        swappobject = array[randomIndex]
        console.log("O: " + currentIndex + " S: " + randomIndex)    
        if(origObj.type != "INFO" && swappobject.type != "INFO") { 
          // And swap it with the current element.
          [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
        } 
      }
    
      return array;
    } 
  var messagesSelfie = $scope.data.constraints.messagesSelfie
  $scope.checks = $scope.data.constraints.checks || []; 
  if($scope.checks.length == 0) {
    var check = {
      "options": {
        "mainImage": false,
        "upload": null,
        "maxHeight": null,
        "type": null
      },
      "completeText": "",
      "completeTime": 1,
      "accuracy": null,
      "label": "Gracias.",
      "time": 1,
      "type": "INFO"
    }
    $scope.checks.push(check)
  }
  
  //JSON.parse('[{ "type": "BLINK_LEFT", "label" : "Cierra tu ojo izquierdo por x segundos", "time"  : 5 }, {"type": "SMILE", "label" : "Sonrie por 3 segundos", "time"  : 5}, {"type": "BLINK_RIGHT", "label" : "Cierra tu ojo derecho por x segundos", "time"  : 5}]');
  $scope.faceAccuracy =  $scope.data.constraints.faceAccuracy;
  $scope.facingMode =  $scope.data.constraints.facingMode == "FRONT" ? "user" : "environment";
  $scope.sampleRate  = $scope.data.constraints.sampleRate || 50;
  var expresionsTypes = {};
  expresionsTypes["BLINK_LEFT"] = {init:"images/lefteye.png", success:"images/lefteye_mark.png", fail:"images/lefteye_fail.png", name:"Parpadear"};
  expresionsTypes["SMILE"] = {init:"images/smile.png", success:"images/smile_mark.png", fail:"images/smile_fail.png", name:"Sonrie"};
  expresionsTypes["BLINK_RIGHT"] = {init:"images/righteye.png", success:"images/righteye_mark.png", fail:"images/righteye_fail.png", name:"Parpadear"};
  expresionsTypes["SERIOUS"] = {init:"images/serius.png", success:"images/serius_mark.png", fail:"images/serius_fail.png", name:"Seria"};
  expresionsTypes["MOUTH_OPEN"] = {init:"images/abreboca.png", success:"images/smile_mark.png", fail:"images/smile_fail.png", name:"Abre la boca"};
  expresionsTypes["RIGHT_SIDE"] = {init:"images/serius.png", success:"images/smile_mark.png", fail:"images/smile_fail.png", name:"Abre la boca"};
  expresionsTypes["LEFT_SIDE"] = {init:"images/serius.png", success:"images/smile_mark.png", fail:"images/smile_fail.png", name:"Abre la boca"};

  $scope.imagesToShow = new Array();
  var imagesTaked = document.getElementById('imagesTaked');
  var imagesTest = document.getElementById('imagesTest');

  
  
  
  
  // callback: launched if a face is detected or lost
  $scope.detect_callback = function(faceIndex, isDetected) {
    if (isDetected) {
      console.log('INFO in detect_callback(): DETECTED');
    } else {
      console.log('INFO in detect_callback(): LOST');
    }
  }

  $scope.msgToast = function(message, type){
    $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .position('top')
        .action('Ok')
        .theme(type)
        .hideDelay(2000)
    );
  };

  $scope.currentTestIndex = 0;
  $scope.currentTestImageIndex = 0;
  $scope.currentTestResult = 0;
  $scope.testData = new Array();

  $scope.currentTest = $scope.checks[$scope.currentTestIndex];

  $scope.currentText = $scope.currentTest.label;
  $scope.currentTestDuration = $scope.currentTest.time * 1000;
  $scope.eyeBlinkCount = 0;
  $scope.smileCount = 0;
  $scope.remainingTime = 5;
  $scope.openMouthCount = 0;
  $scope.leftSideCount = 0;
  $scope.rightSideCount = 0;
  $scope.eyeBlinkCountAux = 0;
  $scope.smileCountAux = 0;
  $scope.BLINK_LEFT = false;
  $scope.BLINK_RIGHT = false;
  $scope.SMILE = false;
  $scope.SERIOUS = false;
 

  $interval(function() {
    $scope.remainingTime--;
    if($scope.remainingTime < 0) $scope.remainingTime = 0; 

   }, 1000); 

   $scope.canvas = document.createElement('canvas'); 
   $scope.canvas.id = "canv";
   $scope.canvas.width = 800;
   $scope.canvas.height = 800;
   $scope.urls = new Array();
   $scope.images = new Array();

   $scope.uploadIndex = 0;
   
   $scope.uploadVideo = function(blob) {
    var blobUrl = URL.createObjectURL(blob);
    const payload = new FormData();
    $scope.format = blob.type.split("/");
    payload.append('type', "face_test");
    payload.append('fileExtension', $scope.format[1]);
    payload.append('latitude', $scope.latitude);
    payload.append('longitude', $scope.longitude);
    payload.append('file', blob, 'filename.mp4');
    
    services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
      if(response.data.url){
        $scope.urls.push(esb +"/security"+ response.data.url);
        console.log("Video " + $scope.uploadIndex + " uploaded  URL: " + esb +"/security"+ response.data.url);
          $scope.videoUrl = esb + "/security" + response.data.url;
                    
        }
    });
   }

   $scope.uploaPicture = function(blob) {
    var blobUrl = URL.createObjectURL(blob);
    const payload = new FormData();
    $scope.format = blob.type.split("/");
    var check = $scope.checksToSend[$scope.uploadIndex - 1];
    var type = (check.options.type || $scope.data.constraints.fileType || "face_test") + "_end";
    console.log("uploaPicture type: " + type + "  index: " + ($scope.uploadIndex - 1))
    payload.append('type', type);
    payload.append('fileExtension', $scope.format[1]);
    payload.append('latitude', $scope.latitude);
    payload.append('longitude', $scope.longitude);
    payload.append('file', blob, 'filename.png'); 
    if(check.options && check.options.upload === false) {
      $scope.uploadIndex ++;
      if(($scope.urls.length) < ($scope.imagesToShow.length  + 1) ) {
        console.log("nextUpload 1")
        $scope.nextUpload();
      } else {
        $scope.progressCircular = undefined;
        $scope.sendPicture();
      }
    } else {
      services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
          if(response.data.url){
            $scope.urls.push(esb +"/security"+ response.data.url);
            console.log("Image " + $scope.uploadIndex + " uploaded  URL: "+ esb +"/security"+ response.data.url);
            
            var check = $scope.checksToSend[$scope.uploadIndex - 1];
            check.url = esb +"/security"+ response.data.url;
            check.url_init = $scope.init_url
            $scope.uploadIndex ++;
            console.log("New Index" + $scope.uploadIndex)
            if($scope.urls.length < ($scope.imagesToShow.length + 1)) {
              console.log("nextUpload 2")
              $scope.nextUpload();
            } else {
              $scope.progressCircular = undefined;
              $scope.sendPicture();
            }
                      
          }
      });

    }
  }
  $scope.firstImageUrl = ""
  function uploadFirstPicture(blob) {
    const payload = new FormData();
    $scope.format = blob.type.split("/"); 
    var type = "selfie";
    console.log("uploadFirstPicture type: " + type)
    payload.append('type', type);
    payload.append('fileExtension', $scope.format[1]);
    payload.append('latitude', $scope.latitude);
    payload.append('longitude', $scope.longitude);
    payload.append('file', blob, 'filename.png'); 
    services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
      if(response.data.url){ 
        $scope.urls.push(esb +"/security"+ response.data.url);
        $scope.uploadIndex ++;
        $scope.mainImageIndex =  $scope.urls.length - 1;
        if($scope.checks.length > 1 ) {
          console.log("nextUpload 3")
          $scope.nextUpload();
        } else {
          $scope.progressCircular = undefined;
          $scope.sendPicture();
        }  
        console.log("First Image uploaded  URL: "+ esb +"/security"+ response.data.url);        
      }
    });

  }
  $scope.init_url = ""
  function uploadInitPicture(blob) {
    const payload = new FormData();
    $scope.format = blob.type.split("/"); 
    var check = $scope.checksToSend[$scope.uploadIndex - 1];
    var type = (check.options.type || $scope.data.constraints.fileType || "face_test") + "_start";
    console.log("uploadInitPicture type: " + type + "  index: " + ($scope.uploadIndex - 1))
    payload.append('type', type);
    payload.append('fileExtension', $scope.format[1]);
    payload.append('latitude', $scope.latitude);
    payload.append('longitude', $scope.longitude);
    payload.append('file', blob, 'filename.png'); 
    services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
      if(response.data.url){ 
        $scope.init_url = esb +"/security"+ response.data.url;        
        var index = ($scope.uploadIndex - 1)
        console.log("INIT Image " + $scope.uploadIndex + " uploaded  URL: "+ esb +"/security"+ response.data.url);
        console.log("nextUpload " + index + " total img " + $scope.images.length)
        $scope.images[index] && $scope.images[index].toBlob($scope.uploaPicture);     
      }
    });

  }

  function uploadFirstImage() {  
    $scope.progressCircular = "ok";  
    firstImageElement.toBlob(uploadFirstPicture);
  }

  $scope.mainImageIndex = 0;
  $scope.nextUpload = function() { 

      $scope.progressCircular = "ok"; 
      var index = ($scope.uploadIndex - 1)
      console.log("uploadInitPicture " + index + " total img " + $scope.images.length)
      $scope.images_init[index] && $scope.images_init[index].toBlob(uploadInitPicture);
    
  }
  $scope.checksToSend = new Array();
  $scope.sendPicture = function(){     
    var message = {text: "Prueba de vida enviada.", url: $scope.urls[0], type: "sent", layout: "end", format: $scope.format[1], typeDocument: "Image"}  //{text: response.data.url, url: blobUrl, type: "sent", layout: "end", format: format[1], typeDocument: "Image"}

    var values = {
      code: "1",
      format: $scope.format[1],
      imageCapture: "mandatory",
      imageType: "face_test",
      type: "String",
      url: $scope.urls[0],
      facingMode: webcam.facingMode,
      video: $scope.videoUrl,
      checks: $scope.checksToSend 
     };

     var value = JSON.stringify(values);
     xmppAuth.Chat.sendMessageImage(xmppUser+"@"+xmpp_domain, "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, message, value);
     $scope.metadataObj = undefined;  
     console.log("Message sent");
     console.log(message);
     $location.path("/dashboard");


  }
  $scope.testTime = (new Date()).getTime();
  $scope.testFunction = function() { 
    if($scope.images.length > ($scope.imagesToShow.length - 1)) {
      uploadFirstImage()        
      $scope.closeDialog();   
      return;         
    }
    isActive = true
    $scope.currentTestIndex++;
    if($scope.currentTest && $scope.currentTest.type != "INFO")
      $scope.currentTestImageIndex++;

    $scope.completeImage = false
    $scope.currentTestResult = 0;  
    $scope.testData = new Array();

    $scope.currentTest = $scope.checks[$scope.currentTestIndex];
    $scope.currentText = $scope.currentTest.label;
    $scope.currentCompleteText = $sce.trustAsHtml($scope.currentTest.completeText);
    $scope.currentTestDuration = ($scope.currentTest.completeTime) * 1000;
    var d = new Date();
    $scope.testTime = d.getTime();
    $scope.currentCompleteTime = $scope.currentTest.time * 1000;
    $scope.eyeBlinkCount = 0;
    $scope.smileCount = 0;
    $scope.SERIOUSCount = 0;
    $scope.remainingTime = $scope.currentTest.time;
    if($scope.currentTest && $scope.currentTest.type != "INFO") {
      $scope.beginingText = $scope.currentTest.label;
      var expres = expresionsTypes[$scope.currentTest.type];
      $scope.beginingImg =  document.getElementById("beginingImg");
      $scope.beginingImg.setAttribute("src", expres.init );
      $scope.headerImg =  document.getElementById("headerImg");
      $scope.headerImg.setAttribute("src", expres.init );

      
      $scope.begining = true;
      $scope.finish = false;

    } else {
      $scope.begining = false;
    }

    if($scope.currentTest.type == "SERIOUS") {
      $scope.SERIOUS = false;
    }
    if($scope.currentTest.type == "MOUTH_OPEN") {
      $scope.OPEN_MOUTH = false;
    }

    if($scope.currentTest.type == "SMILE") {
      $scope.SMILE = false;
    }

    if($scope.currentTest.type == "BLINK_LEFT") {
      $scope.BLINK_LEFT = false;
    }

    if($scope.currentTest.type == "BLINK_RIGHT") {
      $scope.BLINK_RIGHT = false;
    }

    if($scope.currentTestIndex < $scope.checks.length) {
      $scope.startTest();
    }
    return;

  }
  $scope.testCompleteFunction = function(){
    if($scope.cancelled) return;
    if(!$scope.currentTest) {
      $scope.closeDialog();
      return;
    }
    var check =  $scope.currentTest;
     
    if($scope.currentTest && $scope.currentTest.type == "INFO") {
      $scope.complete = true;
      $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

    } else {
      $scope.complete = false;

    } 
    var headerImageRight = document.getElementById("headerImageRight")
    if($scope.currentTest && ($scope.currentTest.type == "BLINK_LEFT" || $scope.currentTest.type == "BLINK_RIGHT")) {
       if($scope.eyeBlinkCount > 0) {
         $scope.eyeBlinkCountAux = 0; 
         $scope.eyeBlinkCount = 0; 
         $scope.images.push(picture);
         $scope.images_init.push(picture_init);
         
        elem = $scope.imagesResult[$scope.currentTestImageIndex];
        var expres = expresionsTypes[check.type];
        elem.setAttribute("src", expres.success ); 
        headerImageRight.setAttribute("src", "images/confirmation.png"); 
        headerImageRight.onload = function () {
          $scope.completeImage = true
       }
        
        $scope.finishText = expres.name;
        $scope.finishTime = $scope.elapseTime;
        $scope.finishImg =  document.getElementById("finishImg");
        $scope.finishImg.setAttribute("src", expres.success );
        $scope.finish = true; 
        check.result = "PASSED";
        check.elapseTime = $scope.elapseTime;
        check.presicion = $scope.SERIOUSPrecision;
        check.probabilityVector = $scope.testData;
        $scope.checksToSend.push(check);
        $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

         return;
     } else { 
       
            canvasImg = document.createElement('canvas');     
            canvasImg.width =  gloabalWidth  
            canvasImg.height = gloabalHeight    
            canvasImg.getContext('2d').drawImage(canvas, gloabaX1, gloabalY1,  gloabalWidth, gloabalHeight, 0, 0, gloabalWidth, gloabalHeight);  
            picture = canvasImg   

           var elem = $scope.imagesToShow[$scope.currentTestImageIndex];  
           elem.setAttribute("src", webcam.snap());
           $scope.images.push(picture);
           $scope.images_init.push(picture_init);
           
          elem = $scope.imagesResult[$scope.currentTestImageIndex];
          var expres = expresionsTypes[check.type];
          elem.setAttribute("src", expres.fail );

              
          $scope.finishText = expres.name;
          $scope.finishTime = $scope.elapseTime;
          $scope.finishImg =  document.getElementById("finishImg");
          $scope.finishImg.setAttribute("src", expres.fail );
          $scope.finish = true;
          headerImageRight.setAttribute("src", "images/confirmation.png"); 
          headerImageRight.onload = function () {
            $scope.completeImage = true
          }
          check.elapseTime = 0;
          check.presicion = 0;
          check.probabilityVector = $scope.testData;
          check.result = "FAILED";
          $scope.checksToSend.push(check);
          $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

           return;

           }
   } 

    if($scope.currentTest && $scope.currentTest.type == "SERIOUS") {
      if($scope.SERIOUSCount > 0) {
          var imagesTaked = document.getElementById('imagesTaked');
          var elem = document.createElement("img");
          var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
           
          $scope.images.push(picture); 
          $scope.images_init.push(picture_init);
          
         elem = $scope.imagesResult[$scope.currentTestImageIndex];
         var expres = expresionsTypes[check.type];
         elem.setAttribute("src", expres.success );


          $scope.finishText = expres.name;
          $scope.finishTime = $scope.elapseTime;
          $scope.finishImg =  document.getElementById("finishImg");
          $scope.finishImg.setAttribute("src", expres.success );
          headerImageRight.setAttribute("src", "images/confirmation.png"); 
          headerImageRight.onload = function () {
            $scope.completeImage = true
          }
          $scope.finish = true;
          check.probabilityVector = $scope.testData;
          check.elapseTime = $scope.elapseTime;
          check.presicion = $scope.SERIOUSPrecision;
          $scope.SERIOUSCount = 0;
          check.result = "PASSED";
          $scope.checksToSend.push(check);
          $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

          return;
      } else {  
            canvasImg = document.createElement('canvas');    
            canvasImg.width =  gloabalWidth  
            canvasImg.height = gloabalHeight     
            canvasImg.getContext('2d').drawImage(canvas, gloabaX1, gloabalY1,  gloabalWidth, gloabalHeight, 0, 0, gloabalWidth, gloabalHeight); 
            picture = canvasImg   

            var elem = $scope.imagesToShow[$scope.currentTestImageIndex]; 
            elem.setAttribute("src", webcam.snap());
            $scope.images.push(picture);
            $scope.images_init.push(picture_init);

            elem = $scope.imagesResult[$scope.currentTestImageIndex];
            var expres = expresionsTypes[check.type];
            elem.setAttribute("src", expres.fail );
            headerImageRight.setAttribute("src", "images/confirmation.png");  
            headerImageRight.onload = function () {
              $scope.completeImage = true
            }
            check.probabilityVector  = $scope.testData;
            $scope.finishText = expres.name;
            $scope.finishTime = $scope.elapseTime; //$scope.SERIOUSPrecision;
            $scope.finishImg =  document.getElementById("finishImg");
            $scope.finishImg.setAttribute("src", expres.fail );
            $scope.finish = true;
            check.presicion = 0;
            check.elapseTime = 0;
            check.result = "FAILED";
            $scope.checksToSend.push(check);
            $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

            return;

            }
    }

    if($scope.currentTest && $scope.currentTest.type == "MOUTH_OPEN") {
      if($scope.openMouthCount > 0) { 
          var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
           
          $scope.images.push(picture);  
          $scope.images_init.push(picture_init);        
        
          elem = $scope.imagesResult[$scope.currentTestImageIndex];
          var expres = expresionsTypes[check.type];
          elem.setAttribute("src", expres.success );
          
          $scope.finishText = expres.name;
          $scope.finishTime = $scope.elapseTime; 
          $scope.finishImg =  document.getElementById("finishImg");
          $scope.finishImg.setAttribute("src", expres.success );
          headerImageRight.setAttribute("src", "images/confirmation.png");  
          headerImageRight.onload = function () {
            $scope.completeImage = true
          }
          $scope.finish = true;

          check.elapseTime = $scope.elapseTime;
          check.presicion = $scope.openMouthPrecision;
          check.probabilityVector = $scope.testData;
          check.result = "PASSED";
          $scope.checksToSend.push(check); 
          $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

          return;
      } else {  
            canvasImg = document.createElement('canvas');    
            canvasImg.width =  gloabalWidth  
            canvasImg.height = gloabalHeight   
            canvasImg.getContext('2d').drawImage(canvas, gloabaX1, gloabalY1,  gloabalWidth, gloabalHeight, 0, 0, gloabalWidth, gloabalHeight); 
            picture = canvasImg   

            var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
             elem.setAttribute("src", webcam.snap());
            $scope.images.push(picture);
            $scope.images_init.push(picture_init);

            elem = $scope.imagesResult[$scope.currentTestImageIndex];
            var expres = expresionsTypes[check.type];
            elem.setAttribute("src", expres.fail );
            headerImageRight.setAttribute("src", "images/confirmation.png"); 
            headerImageRight.onload = function () {
              $scope.completeImage = true
            }
  
            
            $scope.finishText = expres.name;
            $scope.finishTime = $scope.elapseTime;//$scope.smilePrecision;
            $scope.finishImg =  document.getElementById("finishImg");
            $scope.finishImg.setAttribute("src", expres.fail );
            $scope.finish = true;
            check.elapseTime = 0;
            check.presicion = 0;
            check.probabilityVector = $scope.testData;
            check.result = "FAILED";
            $scope.checksToSend.push(check);
            
            $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

            return;

            }
    }
    if($scope.currentTest && $scope.currentTest.type == "SMILE") {
      if($scope.smileCount > 0) {        
         var elem = $scope.imagesToShow[$scope.currentTestImageIndex]; ;
          $scope.images.push(picture);
          $scope.images_init.push(picture_init);          
        
          elem = $scope.imagesResult[$scope.currentTestImageIndex];
          var expres = expresionsTypes[check.type];
          elem.setAttribute("src", expres.success );
          
          $scope.finishText = expres.name;
          $scope.finishTime = $scope.elapseTime; 
          $scope.finishImg =  document.getElementById("finishImg");
          $scope.finishImg.setAttribute("src", expres.success );
          headerImageRight.setAttribute("src", "images/confirmation.png"); 
          headerImageRight.onload = function () {
            $scope.completeImage = true
          }
          $scope.finish = true;

          check.elapseTime = $scope.elapseTime;
          check.presicion = $scope.smilePrecision;
          check.probabilityVector = $scope.testData;
          check.result = "PASSED";
          $scope.checksToSend.push(check);
          $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

          return;
      } else {  
            canvasImg = document.createElement('canvas');    
            canvasImg.width =  gloabalWidth  
            canvasImg.height = gloabalHeight     
            canvasImg.getContext('2d').drawImage(canvas, gloabaX1, gloabalY1,  gloabalWidth, gloabalHeight, 0, 0, gloabalWidth, gloabalHeight); 
            picture = canvasImg   

            
            var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
            elem.setAttribute("src", webcam.snap());
            $scope.images.push(picture);
            $scope.images_init.push(picture_init);

            elem = $scope.imagesResult[$scope.currentTestImageIndex];
            var expres = expresionsTypes[check.type];
            elem.setAttribute("src", expres.fail );
            headerImageRight.setAttribute("src", "images/confirmation.png");  
            headerImageRight.onload = function () {
              $scope.completeImage = true
            }
  
            
            $scope.finishText = expres.name;
            $scope.finishTime = $scope.elapseTime;//$scope.smilePrecision;
            $scope.finishImg =  document.getElementById("finishImg");
            $scope.finishImg.setAttribute("src", expres.fail );
            $scope.finish = true;
            check.elapseTime = 0;
            check.presicion = 0;
            check.probabilityVector = $scope.testData;
            check.result = "FAILED";
            $scope.checksToSend.push(check);            
            $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

            return;

            }
    } 
    

    if($scope.currentTest && $scope.currentTest.type == "LEFT_SIDE") {
      if($scope.leftSideCount > 0) {   
          var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
           
          $scope.images.push(picture);          
          $scope.images_init.push(picture_init);
        
          elem = $scope.imagesResult[$scope.currentTestImageIndex];
          var expres = expresionsTypes[check.type];
          elem.setAttribute("src", expres.success );
          
          $scope.finishText = expres.name;
          $scope.finishTime = $scope.elapseTime; 
          $scope.finishImg =  document.getElementById("finishImg");
          $scope.finishImg.setAttribute("src", expres.success );
          headerImageRight.setAttribute("src", "images/confirmation.png");  
          headerImageRight.onload = function () {
            $scope.completeImage = true
          }
          $scope.finish = true;

          check.elapseTime = $scope.elapseTime;
          check.presicion = $scope.openMouthPrecision;
          check.probabilityVector = $scope.testData;
          check.result = "PASSED";
          $scope.checksToSend.push(check); 
          $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

          return;
      } else {  
            canvasImg = document.createElement('canvas');    
            canvasImg.width =  gloabalWidth  
            canvasImg.height = gloabalHeight  
            canvasImg.getContext('2d').drawImage(canvas, gloabaX1, gloabalY1,  gloabalWidth, gloabalHeight, 0, 0, gloabalWidth, gloabalHeight);  
            picture = canvasImg   

            var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
             elem.setAttribute("src", webcam.snap());
            $scope.images.push(picture);
            $scope.images_init.push(picture_init);

            elem = $scope.imagesResult[$scope.currentTestImageIndex];
            var expres = expresionsTypes[check.type];
            elem.setAttribute("src", expres.fail );
            headerImageRight.setAttribute("src", "images/confirmation.png"); 
            headerImageRight.onload = function () {
              $scope.completeImage = true
            }
  
            
            $scope.finishText = expres.name;
            $scope.finishTime = $scope.elapseTime;//$scope.smilePrecision;
            $scope.finishImg =  document.getElementById("finishImg");
            $scope.finishImg.setAttribute("src", expres.fail );
            $scope.finish = true;
            check.elapseTime = 0;
            check.presicion = 0;
            check.probabilityVector = $scope.testData;
            check.result = "FAILED";
            $scope.checksToSend.push(check);
            
            $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

            return;

            }
    }
    

    if($scope.currentTest && $scope.currentTest.type == "RIGHT_SIDE") {
      if($scope.rightSideCount > 0) { 
          var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
           
          $scope.images.push(picture);   
          $scope.images_init.push(picture_init);       
        
          elem = $scope.imagesResult[$scope.currentTestImageIndex];
          var expres = expresionsTypes[check.type];
          elem.setAttribute("src", expres.success );
          
          $scope.finishText = expres.name;
          $scope.finishTime = $scope.elapseTime; 
          $scope.finishImg =  document.getElementById("finishImg");
          $scope.finishImg.setAttribute("src", expres.success );
          headerImageRight.setAttribute("src", "images/confirmation.png");  
          headerImageRight.onload = function () {
            $scope.completeImage = true
          }
          $scope.finish = true;

          check.elapseTime = $scope.elapseTime;
          check.presicion = $scope.openMouthPrecision;
          check.probabilityVector = $scope.testData;
          check.result = "PASSED";
          $scope.checksToSend.push(check); 
          $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

          return;
      } else { 
            canvasImg = document.createElement('canvas');   
            canvasImg.width =  gloabalWidth  
            canvasImg.height = gloabalHeight     
            canvasImg.getContext('2d').drawImage(canvas, gloabaX1, gloabalY1,  gloabalWidth, gloabalHeight, 0, 0, gloabalWidth, gloabalHeight);       
            picture = canvasImg   

            var elem = $scope.imagesToShow[$scope.currentTestImageIndex];
            elem.setAttribute("src", webcam.snap());
            $scope.images.push(picture);
            $scope.images_init.push(picture_init);

            elem = $scope.imagesResult[$scope.currentTestImageIndex];
            var expres = expresionsTypes[check.type];
            elem.setAttribute("src", expres.fail );
            headerImageRight.setAttribute("src", "images/confirmation.png"); 
            headerImageRight.onload = function () {
              $scope.completeImage = true
            }
  
            
            $scope.finishText = expres.name;
            $scope.finishTime = $scope.elapseTime;//$scope.smilePrecision;
            $scope.finishImg =  document.getElementById("finishImg");
            $scope.finishImg.setAttribute("src", expres.fail );
            $scope.finish = true;
            check.elapseTime = 0;
            check.presicion = 0;
            check.probabilityVector = $scope.testData;
            check.result = "FAILED";
            $scope.checksToSend.push(check);
            
            $scope.currentTimer = $timeout($scope.testFunction, $scope.currentTestDuration);

            return;

            }
    }

  }

  $scope.startTest = function() {
    $scope.BLINK_LEFT = false;
    $scope.BLINK_RIGHT = false;
    $scope.SMILE = false;
    $scope.SERIOUS = false;
    $scope.OPEN_MOUTH = false; 
    $scope.eyeBlinkCount = 0;
    $scope.smileCount = 0;
    $scope.SERIOUSCount = 0;
    $scope.openMouthCount = 0;
    if($scope.cancelled) return; 
    $timeout.cancel($scope.currentTimer);
    $timeout.cancel($scope.currentCompleteTimer);
    if($scope.currentTest && $scope.currentTest.type != "INFO") {
      $scope.beginingText = $scope.currentTest.label;
      var expres = expresionsTypes[$scope.currentTest.type];
      $scope.beginingImg =  document.getElementById("beginingImg");
      $scope.beginingImg.setAttribute("src", expres.init );
      $scope.begining = true;
    } else {
      $scope.begining = false;
    }
    
    $scope.currentCompleteTimer = $timeout($scope.testCompleteFunction, $scope.currentCompleteTime);    
  }

    $scope.main = function() {
      console.log('init Main');
      firstImageTaked = false;
      shuffle($scope.checks)
      $scope.initDone = true;
      $scope.checksToSend = new Array();

      $scope.cancelled = false;
      $scope.canvas = document.createElement('canvas');

      $scope.canvas.id = "canv";
      $scope.canvas.width = 800;
      $scope.canvas.height = 800;
      $scope.urls = new Array();
      $scope.images = new Array();
      $scope.images_init = new Array();
      $scope.firstImage = false
      $scope.uploadIndex = 0;
      $scope.imgSmile = document.getElementById("imgSmile");
      $scope.imgSERIOUS = document.getElementById("imgSERIOUS");
      $scope.imgCheck = document.getElementById("imgCheck");
      $scope.imgBlinkRight = document.getElementById("imgBlinkRight");
      $scope.imgBlinkLeft = document.getElementById("imgBlinkLeft");
      $scope.begining = false;
      $scope.finish = false;
      $scope.complete = false;
      $scope.currentTestIndex = 0;
      $scope.currentTestImageIndex = 0;
      $scope.testData = new Array();
      $scope.captureDataTime = (new Date()).getTime();
      $scope.currentTest = $scope.checks[$scope.currentTestIndex];
      $scope.currentTestResult = 0;
      $scope.currentCompleteText = $sce.trustAsHtml($scope.currentTest.completeText);
      $scope.currentText = $scope.currentTest.label;
      $scope.currentTestDuration = ($scope.currentTest.completeTime) * 1000;
      var d = new Date();
      $scope.testTime = d.getTime();
      $scope.currentCompleteTime = $scope.currentTest.time * 1000;
      $scope.eyeBlinkCount = 0;
      $scope.smileCount = 0;
      $scope.remainingTime = $scope.currentTest.time;
      $scope.SERIOUSCount = 0;
      $scope.eyeBlinkPrecision = 0;
      $scope.SERIOUSPrecision = 0;
      $scope.smilePrecision = 0;
      $scope.openMouthPrecision = 0;
      $scope.eyeBlinkCountAux = 0;
      $scope.smileCountAux = 0;
      $scope.SERIOUSCountAux = 0;

      $scope.imagesToShow = new Array();
      $scope.imagesResult = new Array(); 
      for(var check of $scope.checks) {

        if(check.type != "INFO"){
            var elem = document.createElement("img");
            elem.setAttribute("src", "images/picture.png");
            elem.setAttribute("class","life_proof_taked_item");
            imagesTaked.appendChild(elem);
            $scope.imagesToShow.push(elem);
            elem = document.createElement("img");
            var expres = expresionsTypes[check.type];
            elem.setAttribute("src", expres.init );
            elem.setAttribute("class","life_proof_test_item");
            $scope.imagesResult.push(elem); 
        }
      }  
      console.log('more Main');
      main()
      initSystem()
      console.log('all Main');
  }
 
  $scope.smile = true;
  $scope.smileCount = 0;
  $scope.eyeBlinkCount = 0;
  $scope.SERIOUSCount = 0;
  $scope.openMouthCount = 0; 

 /* ****************************************************************************** */ 
 let running = false
 var isActive = true
 let cameraFrame = null;
 var model = null
 const webcamElement = document.getElementById('webcam');
 const webcam = new Webcam(webcamElement, $scope.facingMode, $scope.canvas);
 let picture = false
 let picture_init = false
 let firstImageElement = false
 let firstImageTaked = false
 let xfactor = 1
 let yfactor = 1 
let canvas = document.getElementById("canvas");
let ctx;
let videoWidth, videoHeight; 
var gloabaX1 = 0
var gloabalY1 = 0
var gloabalWidth = 0
var gloabalHeight = 0
async function main() {
  console.log("setupFaceLandmarkDetection")
  await setupFaceLandmarkDetection() 
  console.log("startTest")
}

async function setupFaceLandmarkDetection() {
  await tf.setBackend('wasm');
}


function drawArrow(ctx, fromx, fromy, tox, toy, arrowWidth, color){ 
  var headlen = 10;
  var angle = Math.atan2(toy-fromy,tox-fromx);

  ctx.save();
  ctx.strokeStyle = color;
 
  ctx.beginPath();
  ctx.moveTo(fromx, fromy);
  ctx.lineTo(tox, toy);
  ctx.lineWidth = arrowWidth;
  ctx.stroke();
 
  ctx.beginPath();
  ctx.moveTo(tox, toy);
  ctx.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),
             toy-headlen*Math.sin(angle-Math.PI/7));
 
  ctx.lineTo(tox-headlen*Math.cos(angle+Math.PI/7),
             toy-headlen*Math.sin(angle+Math.PI/7)); 
  ctx.lineTo(tox, toy);
  ctx.lineTo(tox-headlen*Math.cos(angle-Math.PI/7),
             toy-headlen*Math.sin(angle-Math.PI/7));
 
  ctx.stroke();
  ctx.restore();
}

var timeAfterInit = 0
var timeCurrentMessage = 0
var messageIndex = 0
var messageTexts = messagesSelfie || [{text: 'Preparate, se te tomará una foto', time:2}, {text: '¿Preparado?', time: 1} , {text: 'Empecemos', time: 1}, {text: '¡Listo!', time: 0} ]
async function startCapture() {   
  console.log("captura de imagenes iniciada")    
        $scope.progressCircularModel = false
        isActive = true     
        timeAfterInit = (new Date()).getTime()
        cameraFrame = detectKeyPoints();        
        running = true;
}
var faceBounderie = [] 
$scope.showImageTake = false
$scope.testOnline = false

$scope.onTakeImage = function() {
  $scope.showImageTake = true
}

$scope.onContinueTest = function() {
  $scope.testOnline = true
  $scope.startTest(); 
}
  
$scope.takeAgain = function() {
  $scope.showImageTake = false
  timeAfterInit = (new Date()).getTime()
  messageIndex = 0
  timeCurrentMessage = 0
  firstImageTaked = false
}

$scope.flipCamera = function() {
  webcam.flip()
  initSystem()
}
 
var captureInit = true

async function detectKeyPoints() {
  let videoElement = document.getElementById("webcam")
 
  ctx.drawImage(
    videoElement, 0, 0, videoElement.width, videoElement.height, 0, 0, canvas.width, canvas.height);

      if(!$scope.testOnline) {      
        var currentTimeAfterInit =  Math.round(((new Date()).getTime() - timeAfterInit) / 1000)      
        var currentMessage = messageTexts[messageIndex]
        $scope.currentText = currentMessage.text
        if((currentTimeAfterInit - timeCurrentMessage) > currentMessage.time) {
          timeCurrentMessage = currentTimeAfterInit
        
          if(messageIndex >= messageTexts.length - 1) {
            $scope.showImageTake = true
            messageIndex = messageTexts.length - 1
          } else {
            messageIndex++ 
          }
        }
      }
      var width = canvas.width
      var height = canvas.height               
      const x1 = 0;
      const y1 = 0; 
      gloabalWidth = canvas.width
      gloabalHeight = canvas.height    
      gloabaX1 = x1
      gloabalY1 = y1 


      if($scope.showImageTake && !firstImageTaked) {
        canvasImg = document.getElementById('canvasWebcam');   
        canvasImg.width = width  
        canvasImg.height = height     
        canvasImg.getContext('2d').drawImage(canvas, 0, 0,  width, height, 0, 0, width, height);     
        firstImageElement = canvasImg  
        firstImageTaked = true        
        console.log("firstImageTaked")
      }

      if(captureInit) {
          canvasImg = document.createElement('canvas');   
          canvasImg.width =  width  
          canvasImg.height = height     
          canvasImg.getContext('2d').drawImage(canvas, 0, 0,  width, height, 0, 0, width, height);  
          picture_init = canvasImg        
          captureInit = false
      }  
    
  
  cameraFrame = requestAnimationFrame(detectKeyPoints);
}

const BLINK_RIGHT_EYE = 'BLINK_RIGHT' 
const OPEN_MOUTH = 'MOUTH_OPEN'
const SERIOUS = 'SERIOUS' 
const BLINK_LEFT_EYE = 'BLINK_LEFT'
const SMILE = 'SMILE'
const LEFT_SIDE = "LEFT_SIDE"
const RIGHT_SIDE = "RIGHT_SIDE"
  
async function stopCapture() {
  if (running) { 
      running = false;
      if (cameraFrame != null) {
          cancelAnimationFrame(cameraFrame);
      }
  }
}

function initSystem() {
    webcam.start().then(result => { 
      webcamElement.onloadedmetadata = () => {
        videoWidth = webcamElement.videoWidth;
        videoHeight = webcamElement.videoHeight;
        webcamElement.width = videoWidth;
        webcamElement.height = videoHeight; 
        setupCanvas();
        startCapture();
    };  
      

      })
      .catch(err => {
          console.log(err);
      });

  } 
  var aspectRatio = 1

  async function setupCanvas() { 
    var containerCamera = document.getElementById('canvasContainer');
    $('#canvasContainer').empty(); 

    canvas = document.createElement('canvas');
    canvas.style.transform = 'scale(-1, 1)'
    canvas.id = "canvas" + Math.round((Math.random() * 100));
    canvas.width = videoWidth;
    canvas.height = videoHeight;  
    aspectRatio = videoHeight / videoWidth 
    console.log("aspectRatio " + aspectRatio)
    if(window.innerHeight > 800 && window.innerWidth > 800 ) {
      canvas.width = videoWidth;
      canvas.height = videoHeight;
    } else {
      let width = 500
      let height = width * aspectRatio
      canvas.width = width;
      canvas.height = height;  
      yfactor = height / videoHeight
      xfactor = width / videoWidth
      console.log("xfactor " + xfactor)
      console.log("yfactor " + yfactor)

    }  
    canvas.setAttribute("style", "z-index: 1000;border:gray solid 2px");
    containerCamera.appendChild(canvas); 
    ctx = canvas.getContext('2d'); 
  }  

  $scope.$on("msgRecievedBroadcast", function (event, data, type) {
    switch (type) {
        case "ack":
            $scope.safeApply($scope.msgACK(data));
            break;
        default:
            $scope.safeApply($scope.messageReceive(data))
            break;
    }
});
$scope.safeApply = function (fn) {
  var phase = this.$root.$$phase;
  if (phase === "$apply" || phase === "$digest") {
      if (fn && typeof fn === "function") {
          fn()
      }
  } else {
      this.$apply(fn)
  }
};
$scope.msgACK = function (data) {
  console.log(data);
  const resultado = $scope.messages.find(msg => msg.id === data);
  if (resultado !== undefined) {
      resultado.icon = "checkblue.png";
      resultado.ack = true;
  }
}

$scope.messageReceive = function (data) {
  if (data.text) {
      if (data.id) {
          $scope.dataId = data.id;
          $cookieStore.put("id", data.id, {})
      }
      $scope.messages.push(data);
      $localStorage.msg = $scope.messages
      
  }
}

$scope.messages = [];
if ($localStorage.msg)
  $scope.messages = $localStorage.msg;

});